import { PrefectureList } from '../components/prefecture-list/prefecture-list';
import Layout from '../layouts/layout';
import { type Region } from '../types';
import styles from './index.module.css';

type HomePageProps = {
  regions: Region[];
};

export default function HomePage(props: HomePageProps) {
  return (
    <Layout>
      <div className={styles.info}>
        <h2 className={styles.heading}>
          Looking to study in Japan?
          <br />
          Time to find the right school!
        </h2>
        <p className={styles.text}>Click a city below to get started</p>
      </div>
      <PrefectureList regions={props.regions} />
    </Layout>
  );
}
